import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Label} from '@cred/react-label'
import {FormField} from '@cred/react-form-field'
import {isTablet} from '@cred/shared/utils'
import NumberFormat from 'react-number-format'
import styles from './styles.module.scss'

class InputComponent extends Component {
  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    small: PropTypes.bool,
    id: PropTypes.string,
    getInputRef: PropTypes.func,
    decimalScale: PropTypes.number,
    fixedDecimalScale: PropTypes.bool,
    placeholder: PropTypes.string,
    customInputProps: PropTypes.object,
    type: PropTypes.oneOf(['text', 'tel']),
    isAllowed: PropTypes.func.isRequired
  }

  static defaultProps = {
    input: {},
    label: '',
    meta: {},
    small: false,
    id: '',
    getInputRef: () => {},
    decimalScale: 2,
    fixedDecimalScale: false,
    placeholder: '%',
    customInputProps: {},
    type: 'text',
  }



  render() {
    const {
        input,
        label,
        meta,
        small,
        id,
        getInputRef,
        decimalScale,
        fixedDecimalScale,
        placeholder,
        customInputProps,
        type,
        isAllowed
      } = this.props,
      inputWithCustomProps = Object.assign({}, input, customInputProps)

    return (
      <FormField
        status={meta}
        error={meta.error}
        signRightPosition
        small={small}
        value={inputWithCustomProps.value}
        label={label}
      >
        <div
          className={styles.inputContainer}
          data-tip
          data-effect="solid"
          data-place={isTablet() ? 'bottom' : 'right'}
          data-for={inputWithCustomProps.name}
          ref={elem => this.inputRef = elem}
        >
          <div className={[styles.input, small ? styles.smallInput : ''].join(' ')}>
            <NumberFormat
              isAllowed={({floatValue}) => isAllowed(floatValue)}
              decimalScale={decimalScale}
              allowNegative={false}
              type={type}
              placeholder={placeholder}
              id={id || inputWithCustomProps.name}
              getInputRef={getInputRef}
              fixedDecimalScale={fixedDecimalScale}
              {...inputWithCustomProps}
            />
          </div>
          <div className={[styles.sign, small ? styles.smallSign : ''].join(' ')}>%</div>
        </div>
        <Label htmlFor={id || inputWithCustomProps.name}>{label}</Label>
      </FormField>
    )
  }
}

export {InputComponent}
